var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWarning32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 23a1 1 0 100-2 1 1 0 000 2zm.743-11.102A.75.75 0 0015.25 12v7l.007.102A.75.75 0 0016.75 19v-7l-.007-.102z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.148 24.162L14.464 5.25a1.75 1.75 0 013.072 0l10.316 18.912a1.75 1.75 0 01-1.536 2.588H5.685a1.75 1.75 0 01-1.537-2.588zM16.22 5.969a.25.25 0 00-.1-.1l-.063-.024a.25.25 0 00-.276.124L5.465 24.88a.25.25 0 00.22.37h20.63a.25.25 0 00.22-.37L16.22 5.969z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning32);
export default __webpack_public_path__ + "static/media/icon-warning-32.8e08ce1d.svg";
export { ForwardRef as ReactComponent };